<template>
  <v-container fill-height fluid>
    <v-row justify="center" align="center" fill-height style="height: 100%">
      <v-col class="text-center">
        <div class="display-4 primary--text">
          404
        </div>
        <div class="display-1">
          Not found
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
